import script from "./Step0Register.vue?vue&type=script&setup=true&lang=js"
export * from "./Step0Register.vue?vue&type=script&setup=true&lang=js"

import "./Step0Register.vue?vue&type=style&index=0&id=e843bd7e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e843bd7e"]])

export default __exports__